import { createFileRoute } from "@tanstack/react-router"

import { PageHeader } from "@/components/common/page-header"
import { FirmPeople } from "@/features/appointments/components/firm-people"
import { FirmPeopleActions } from "@/features/appointments/components/firm-people-actions"
import { FoundPeople } from "@/features/appointments/components/found-people"
import { appointmentQueries } from "@/queries/appointments"
import { foundPeopleQueries } from "@/queries/found-people"
import { ownershipQueries } from "@/queries/ownership"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/people/"
)({
  staticData: { attention: "firm.people" },
  loader: ({ context, params }) => {
    void context.queryClient.prefetchQuery(ownershipQueries.firm(params.firmId))
    void context.queryClient.prefetchQuery(
      foundPeopleQueries.forFirm(params.firmId)
    )

    return context.queryClient.ensureQueryData(
      appointmentQueries.listForFirm(params.firmId)
    )
  },
  component: FirmPeoplePage,
})

function FirmPeoplePage() {
  const { firmId } = Route.useParams()

  return (
    <>
      <PageHeader
        title="People"
        actions={<FirmPeopleActions firmId={firmId} />}
      />
      <div className="flex flex-col gap-8">
        <FoundPeople firmId={firmId} />
        <FirmPeople firmId={firmId} />
      </div>
    </>
  )
}
